import React from 'react';
import './ColumnArrow.css';

export interface Props {
  value: string;
  sortValue: string;
  isReversed: boolean;
}

export const ColumnArrow = (props: Props) => {
  const { value, sortValue, isReversed } = props;

  let arrowClasses: string = 'column__arrow';

  if (value !== sortValue) {
    arrowClasses += '';
  } else if (!isReversed) {
    arrowClasses += ' column__arrow--up';
  } else if (isReversed) {
    arrowClasses += ' column__arrow--down';
  }
  return (
    <span className="column-name-arrow">
      <span className={arrowClasses} />
    </span>
  );
};
